import React, { Component } from "react";
import { Grid, Row, Col, Image, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";



export default class AboutAdvisoryBoard extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background">
                    <Banner heading="The Advisory Board" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <div className="photo-header">
                        <Image src="/assets/0710_GWI_Madrid_Sue Murphy-53fff7c661b39c2590ef85607f820be788ab346f3a40f97f87ba4870988e99e2.jpg" />
                    </div>
                    <Button className="meet-the-board" href={hyperlinks["advisoryBoardMembers"]}>{"Meet the board ❯"}</Button>
                    <Row>
                        <Col md={4}>
                            <div className="chairman">
                                <Image src="/assets/john-ringham-77e98a247beea1f4dcc886ea2ca30fbca2a8fa94a56433fc82a7d7c12fe31734.jpg" />
                                <h2>Chairman of the Advisory Board</h2>
                                <p>John Ringham</p>
                                <Button href={hyperlinks["advisoryBoardChairman"]}>Learn More</Button>
                            </div>
                            <div className="chairman">
                                <Image src="/assets/Howard Neukrug_black&white-195d58fed755b6395aae58642524d820c0e969ee0bf10f252c30192c0d94bf85.JPG" />
                                <h2>Deputy Chairman of the Advisory Board</h2>
                                <p>Howard Neukrug</p>
                                <Button href={hyperlinks["advisoryBoardDeputyChairman"]}>Learn More</Button>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="about-advisory-board">
                                <h2>What it means to be on the Advisory Board</h2>
                                <p>
                                    The Advisory Board is currently made up of six utility members from around the world, in addition to the Chairman, John Ringham, former CEO of South Australian Water Corporation, and Deputy Chairman, Howard Neukrug, former CEO of the Philadelphia Water Department and Senior Advisor to the Global Water Leaders Group.
                                </p>

                                <p>
                                    The leadership of each utility represented on the Advisory Board aids John Ringham in nominating and then selecting new utilities for inauguration into the LUOW network. A leadership-level representative of each Advisory Board utility is invited to all LUOW events where new members are inaugurated and gives feedback to the newest member utilities on their presentation and innovation areas.
                                </p>

                                <p>
                                    Utilities represented on the Advisory Board are notable because they have <span className="blue-text"><strong>unimpeachable records of performance and innovation</strong></span>. They are experts and action-leaders in many areas of utility management, as measured by the LUOW network's 14 distinct <a href={hyperlinks["innovationAreas"]}>areas of innovation</a>.
                                </p>

                                <p>
                                    The Board members are forward-looking, they collaborate internationally, and they share their considerable knowledge with other utilities. They understand that collaboration will help them be more innovative in the future. <span className="blue-text"><strong>They are the benchmark for peak performance in the sector</strong></span>.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/AboutAdvisoryBoard.jsx.erb